import { User } from "@/shared/models/user";

const userMockData: User = {
  id: "1",
  firstName: "John",
  middleName: "A",
  lastName: "Smith",
  email: "johnsmith@example.com",
  phoneNumber: "+1 8679921888",
};

export default userMockData;
